waitlistModal.$inject = ["API_URL", "$http", "$rootScope", "$timeout", "$location"];

var moment = require('moment-timezone');

angular.module('calendarApp').directive('waitlistModal', waitlistModal);

function waitlistModal(API_URL, $http, $rootScope, $timeout, $location) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: smooth.calendar_url + '/partials/directives/waitlist-modal.html',
    scope: {
      launchModal: '='
    },
    link: function link(scope, elem, attrs) {
      scope.launchModal = function (timeslot, shiftid) {
        scope.shiftid = shiftid || timeslot.shiftid;
        moment.tz.setDefault(timeslot.timezone);
        scope.service = timeslot.service;
        scope.resource = timeslot.resource;
        scope.start = moment.unix(timeslot.start).format('lll');
        scope.end = moment.unix(timeslot.end + 1).format('lll');
        scope.timeslot = timeslot;
        $('#waitlist-modal').modal();
      };

      scope.addToWaitlist = function () {
        var timeslotid = "".concat(scope.timeslot.start, "-").concat(scope.timeslot.end, "-").concat(scope.shiftid);
        scope.loading = true; // Add the customer to the waitlist

        $http.post(API_URL + "/api/v1/calendar/waitlist/", {
          timeslotid: timeslotid
        }).then(function (_ref) {
          var response = _ref.data;
          scope.loading = false;

          if (!response.success) {
            scope.apiError = "Sorry but an error occurred: ".concat(response.msg);
            $timeout(function () {
              scope.apiError = '';
            }, 3000);
            return;
          }

          scope.addSuccess = true;
          $timeout(function () {
            scope.addSuccess = false;
            $('#waitlist-modal').modal('hide');
            $location.path('/');
          }, 5000);
        }).catch(function (err) {
          console.error(err);
          scope.apiError = "Sorry but an error occurred: ".concat(err.message);
        });
      };
    }
  };
}